import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutSeriesRange} from '../application/ports/workout.repository';
import type {WorkoutsDependencies} from '../dependencies';
import {keys} from './keys';

export type GetCompletedWorkoutSeriesQueryDependencies = Pick<
  WorkoutsDependencies,
  'controllers'
>;

export const getCompletedWorkoutSeriesQuery = (
  {controllers}: GetCompletedWorkoutSeriesQueryDependencies,
  range: WorkoutSeriesRange,
) =>
  queryOptions({
    queryKey: keys.series(range),
    queryFn: () => controllers.workoutController.series(range).then(unwrap),
  });
